<template>
  <div class="modal-overlay" @click.self="$emit('close')">
    <div class="modal-content">
      <h3>Create New Group</h3>
      <hr />

      <div class="form-group mb-3">
        <label>Group Name</label>
        <input v-model="groupName" class="form-control" placeholder="e.g. Marketing Team" />
      </div>

      <div class="form-group mb-3">
        <label>Description (Optional)</label>
        <textarea v-model="groupDesc" class="form-control"></textarea>
      </div>

      <div class="form-group mb-3">
        <label>Invite Members (Search by name or email)</label>
        <input 
          v-model="searchQuery" 
          @input="handleSearch" 
          class="form-control" 
          placeholder="Search..." 
        />
        
        <ul v-if="searchResults.length" class="list-group mt-1 search-results">
          <li 
            v-for="user in searchResults" 
            :key="user.id" 
            @click="addMember(user)"
            class="list-group-item list-group-item-action cursor-pointer"
          >
            {{ user.username }} ({{ user.email }})
          </li>
        </ul>
      </div>

      <div class="mb-3 d-flex flex-wrap gap-2">
        <span v-for="m in selectedMembers" :key="m.id" class="badge bg-primary p-2">
          {{ m.username }} 
          <span @click="removeMember(m.id)" class="ms-2 cursor-pointer">&times;</span>
        </span>
      </div>

      <div class="d-flex justify-content-end gap-2">
        <button @click="$emit('close')" class="btn btn-secondary">Cancel</button>
        <button 
          @click="submitGroup" 
          :disabled="!groupName || isSubmitting" 
          class="btn btn-success"
        >
          {{ isSubmitting ? 'Creating...' : 'Create Group' }}
        </button>
      </div>
    </div>
  </div>
</template>
 
   
<script>
import { groupsService } from "@/services/groupsService";

export default {
  name: "CreateGroupModal",
  data() {
    return {
      groupName: "",
      groupDesc: "",
      searchQuery: "",
      searchResults: [],
      selectedMembers: [], 
      isSubmitting: false,
      searchTimer: null  
    };
  },
  methods: {
    handleSearch() {
      
      clearTimeout(this.searchTimer);

      if (this.searchQuery.trim().length < 2) {
        this.searchResults = [];
        return;
      }

      // انتظر 300 مللي ثانية بعد توقف المستخدم عن الكتابة قبل إرسال الطلب
      this.searchTimer = setTimeout(async () => {
        try {
          console.log("Searching for:", this.searchQuery); // للتأكد من النص المرسل
          const users = await groupsService.searchUsers(this.searchQuery);
          
          // تأكد من أن السيرفر يعيد قائمة (Array)
          if (Array.isArray(users)) {
            // فلترة النتائج لاستبعاد المستخدمين المختارين مسبقاً
            this.searchResults = users.filter(u => 
              !this.selectedMembers.find(m => m.id === u.id)
            );
          }
        } catch (err) {
          console.error("Search failed:", err);
        }
      }, 300);
    },

    addMember(user) {
      // منع إضافة نفس المستخدم مرتين
      if (!this.selectedMembers.find(m => m.id === user.id)) {
        this.selectedMembers.push(user);
      }
      this.searchQuery = "";
      this.searchResults = [];
    },

    removeMember(userId) {
      this.selectedMembers = this.selectedMembers.filter(m => m.id !== userId);
    },

    async submitGroup() {
      if (this.isSubmitting) return;
      this.isSubmitting = true;
      try {
        const groupResponse = await groupsService.createGroup({
          name: this.groupName,
          description: this.groupDesc
        });

        const newGroupId = groupResponse.groupId || groupResponse.id;

        if (this.selectedMembers.length > 0) {
          await groupsService.addMembers({
            groupId: newGroupId,
            userIds: this.selectedMembers.map(m => m.id)
          });
        }

        this.$emit('groupCreated'); 
        this.$emit('close');
      } catch (err) {
        console.error("Creation Error:", err.response?.data || err.message);
        alert("Error: " + (err.response?.data?.message || "Could not create group"));
      } finally {
        this.isSubmitting = false;
      }
    }
  }
};
</script>
<style scoped>
.modal-overlay {
  position: fixed; top: 0; left: 0; width: 100%; height: 100%;
  background: rgba(0,0,0,0.5); display: flex; align-items: center; justify-content: center;
  z-index: 1000;
}
.modal-content {
  background: white; padding: 2rem; border-radius: 8px; width: 500px;
}
.cursor-pointer { cursor: pointer; }
.search-results { max-height: 200px; overflow-y: auto; position: absolute; width: 90%; z-index: 10; }
</style>